export const DRAWER_WIDTH = 275;



// WEBPACK FOOTER //
// ./src/modules/App/constants.js